export default "__VITE_ASSET__lkFky3jX__ 1250w";